export const editRegex = /\/app\/property-landing\/edit/;
export const createRegex = /\/app\/property-landing\/create/;
